// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Tag2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Tag2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.525 7.25 12.75 3.475a3.959 3.959 0 0 0-3-1.158l-4.167.2a3.22 3.22 0 0 0-3.075 3.058l-.2 4.167a3.99 3.99 0 0 0 1.159 3l3.775 3.775a3.984 3.984 0 0 0 5.625 0l3.658-3.659a3.948 3.948 0 0 0 0-5.608Zm-8.608 3.067a2.406 2.406 0 0 1-2.4-2.4c0-1.325 1.083-2.4 2.4-2.4 1.316 0 2.4 1.075 2.4 2.4s-1.084 2.4-2.4 2.4Zm6.691.958-3.333 3.333a.618.618 0 0 1-.442.184.618.618 0 0 1-.441-.184.629.629 0 0 1 0-.883l3.333-3.333a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883Z"
}));
export default Tag2Icon;